import React from 'react';
import { Typography, Row, Col } from 'antd';
import { CSVLink, UploadDragger } from '@common/components';
import { RcFile } from 'antd/lib/upload';

const { Text } = Typography;

const csvTemplateContent = [
  ['unit', 'start_date_time', 'end_date_time', 'role', 'openings'],
  ['2273', '5/1/23 5:00', '5/1/23 17:00', 'LVN / LPN', '3'],
  ['Some Unit', '5/1/23 5:00', '5/1/23 17:00', '1', '5'],
];

type Props = {
  csvFile: RcFile | null;
  handleFileUpload: (file: RcFile) => boolean;
};

export function ShiftsAddMultipleUpload({ csvFile, handleFileUpload }: Props) {
  return (
    <div className="shifts-add-multiple-upload-step">
      <Row>
        <Col span={24} style={{ marginBottom: 24 }}>
          <Text>
            <CSVLink
              data={csvTemplateContent}
              fileName="shifts_upload_template"
            >
              Download the .CSV template
            </CSVLink>{' '}
            to update the shifts you’d like in Works.
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <UploadDragger
            accept=".csv"
            fileList={csvFile ? [csvFile] : []}
            beforeUpload={handleFileUpload}
            hideActions={true}
          />
        </Col>
      </Row>
      <style jsx>{`
        .shifts-add-multiple-upload-step :global(h1.ant-typography) {
          font-size: 30px;
        }
        .shifts-add-multiple-upload-step :global(span.ant-typography) {
          font-size: 16px;
        }
      `}</style>
    </div>
  );
}
